import React from "react";
import styled from "styled-components";
import { FontSize } from "../../themes/Fonts";
import LifeAtButton from "../LifeAtButton/LifeAtButton";
import LifeAtToastContainer from "./LifeAtToastContainer";

const ErrorMessageTextContainer = styled.div`
    display: flex;
`;

const ErrorEmojiContainer = styled.div`
    padding-right: 8px;
    font-size: ${FontSize.large};
    color: ${(props) => props.theme.textColorPrimary};
`;

const ErrorMsgText = styled.div`
    padding-right: 8px;
    font-size: ${FontSize.small};
    color: ${(props) => props.theme.textColorPrimary};
    width: auto;
    height: auto;
    align-self: center;
`;

const ErrorSignOut = styled(LifeAtButton)`
    width: fit-content;
    padding: 5px;
    min-height: unset;
    background: ${(props) => props.theme.textColorPrimary} !important;

    * {
        background: ${(props) => props.theme.textColorPrimary} !important;
        color: ${(props) => props.theme.backgroundPrimary} !important;
    }

    button {
        font-size: ${FontSize.small};
    }
`;

export interface LifeAtErrorToastProps {
    readonly errorMessage: string;
    readonly handleClose?: () => void;
    readonly actionLabel?: string;
}
export default function LifeAtErrorToast(props: LifeAtErrorToastProps) {
    const content = (
        <ErrorMessageTextContainer>
            <ErrorEmojiContainer>⚠</ErrorEmojiContainer>
            <ErrorMsgText>{props.errorMessage}</ErrorMsgText>
        </ErrorMessageTextContainer>
    );
    const button = (
        <ErrorSignOut
            className={`lifeat-error-toast-button`}
            isLink={false}
            text={props.actionLabel ?? "Confirm"}
            handleClick={() => props.handleClose()}
        />
    );

    return <LifeAtToastContainer toastContent={content} button={button} />;
}
